var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('popup-dialog',{attrs:{"title":_vm.title},on:{"close":_vm.close}},[_c('div',{staticClass:"html-desc",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }